import { ref, watch } from 'vue';

import type { FischerPlugin } from '@/lib/fischerPlugin';

export const DEFAULT_ORDER_UNIT = 'ST';

const devOverride = ref('');

if (IS_SHOWROOM && !IS_SSR) {
  void import('@/components/dev/dev-order-unit-picker-fi/devPreferredOrderUnit').then(
    ({ devPreferredOrderUnit }) => {
      watch(
        devPreferredOrderUnit,
        (unit) => {
          devOverride.value = unit;
        },
        { immediate: true },
      );
    },
  );
}

export const readPreferredOrderUnit = (fischer: FischerPlugin | null): string => {
  if (!fischer?.user?.getSalesforce?.()) {
    return DEFAULT_ORDER_UNIT;
  }
  return devOverride.value || fischer.user.preferredOrderUnit?.() || DEFAULT_ORDER_UNIT;
};

export const readPriceUnit = (fischer: FischerPlugin | null): string | undefined => {
  const unit = readPreferredOrderUnit(fischer);
  return unit === DEFAULT_ORDER_UNIT ? undefined : unit;
};
